import { createContext, useEffect } from "react";
import { useState } from "react";

export const organizationDetail = createContext();

const OrganizationDetailContext = ({ children }) => {
  const [organizationData, setOrganizationData] = useState({});
  return (
    <organizationDetail.Provider
      value={{ organizationData, setOrganizationData }}
    >
      {children}
    </organizationDetail.Provider>
  );
};

export default OrganizationDetailContext;
